
const LOOMO_PLATFORMS = [
    {
        n: '01', icon: 'icon-bot', name: 'LOOMO Agent', tag: 'AUTONOMOUS AI AGENTS',
        accent: '#8B5CF6', tint: 'linear-gradient(120deg, #EFE8FE 0%, #F8F5FF 55%, #FFFFFF 100%)',
        body: 'Deploy, orchestrate, and govern intelligent AI agents that automate workflows, collaborate with your teams, and drive smarter enterprise outcomes.',
    },
    {
        n: '02', icon: 'icon-database', name: 'LOOMO ERP', tag: 'ENTERPRISE OPERATIONS',
        accent: '#E5308A', tint: 'linear-gradient(120deg, #FCE4F0 0%, #FFF4F9 55%, #FFFFFF 100%)',
        body: 'A modern, AI-enabled ERP platform to run finance, HR, supply chain, manufacturing, and operations — all on one intelligent backbone.',
    },
    {
        n: '03', icon: 'icon-chart-line', name: 'LOOMO Simulator', tag: 'BUSINESS SIMULATION',
        accent: '#2F6BE0', tint: 'linear-gradient(120deg, #E4EEFB 0%, #F4F8FE 55%, #FFFFFF 100%)',
        body: 'Model future business outcomes before making strategic decisions. Digital twins, scenario planning, and predictive analytics for the C-suite.',
    },
];

function loomoPlatformSliderMarkup() {
    const cards = LOOMO_PLATFORMS.map(p => `
        <div class="platform-card" style="background:${p.tint};">
            <div class="platform-card-top">
                <span class="platform-num" style="color:${p.accent};">${p.n}</span>
                <svg class="platform-icon" style="color:${p.accent};"><use href="#${p.icon}"></use></svg>
            </div>
            <div class="platform-name">${p.name}</div>
            <div class="platform-tag" style="color:${p.accent};">${p.tag}</div>
            <p class="platform-body">${p.body}</p>
        </div>
    `).join('');
    const dots = LOOMO_PLATFORMS.map((p, idx) => `
        <button type="button" class="platform-dot${idx === 0 ? ' is-active' : ''}" data-index="${idx}" aria-label="Show ${p.name}" style="${idx === 0 ? `background:${p.accent};` : ''}"></button>
    `).join('');
    return `
        <div class="platform-slider">
            <div class="platform-viewport">
                <div class="platform-track" style="width:${LOOMO_PLATFORMS.length * 100}%;">
                    ${cards}
                </div>
            </div>
            <div class="platform-dots">${dots}</div>
        </div>
    `;
}

function loomoInitPlatformSlider(root) {
    const slider = root.querySelector('.platform-slider');
    if (!slider) return;
    const track = slider.querySelector('.platform-track');
    const dots = Array.from(slider.querySelectorAll('.platform-dot'));
    const count = LOOMO_PLATFORMS.length;
    let index = 0;
    let timer = null;

    function render() {
        track.style.transform = `translateX(-${index * (100 / count)}%)`;
        dots.forEach((dot, idx) => {
            const active = idx === index;
            dot.classList.toggle('is-active', active);
            dot.style.background = active ? LOOMO_PLATFORMS[idx].accent : '';
        });
    }
    function goTo(idx) {
        index = ((idx % count) + count) % count;
        render();
    }
    function start() {
        stop();
        timer = setInterval(() => goTo(index + 1), 4500);
    }
    function stop() {
        if (timer) clearInterval(timer);
        timer = null;
    }

    dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => { goTo(idx); start(); });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    render();
    start();
}

document.addEventListener('DOMContentLoaded', () => {
    // Nhận diện trang login bằng DOM, KHÔNG bằng window.location.pathname.
    //
    // ⚠ Bản trước gate theo pathname (`=== '/login'`) và hỏng đúng ở trường hợp phổ
    //   biến nhất: khách gõ tên miền trần. Guest vào "/" thì Frappe render CHÍNH trang
    //   login — `get_home_page()` trả "login" cho Guest (frappe/website/utils.py:125) —
    //   nhưng pathname vẫn là "/", nên toàn bộ khối layout bị bỏ qua: không sidebar,
    //   không `loomo-split-layout`, không `loomo-layout-ready`.
    //   Triệu chứng quan sát được: vào lần đầu thì layout vỡ, đăng nhập rồi đăng xuất
    //   lại bình thường (vì logout điều hướng tới "/login" nên pathname mới khớp).
    //
    //   Đã đối chiếu HTML thật: "/" và "/login" trả về markup giống hệt nhau, đều có
    //   `id="page-login"` và `data-path="login"`. Nên kiểm tra `#page-login` là đúng
    //   cho cả hai đường vào, và cũng phủ luôn trạng thái signup/forgot nằm trong
    //   cùng trang login của Frappe.
    if (document.getElementById('page-login')) {
        const pageContent = document.querySelector('#page-login .page_content');
        if (pageContent && !document.querySelector('.loomo-marketing-sidebar')) {
            pageContent.classList.add('loomo-split-layout');
            const marketingSidebar = document.createElement('div');
            marketingSidebar.className = 'loomo-marketing-sidebar';
            marketingSidebar.innerHTML = `
                <div class="marketing-blob marketing-blob-a"></div>
                <div class="marketing-blob marketing-blob-b"></div>
                <div class="marketing-header">
                    <img src="/assets/loomo/images/logo.png" class="marketing-logo" alt="Loomo">
                </div>
                <div class="marketing-hero">
                    <div class="marketing-badge"><span class="marketing-badge-text">✦ AI-POWERED · ENTERPRISE-GRADE · FUTURE-READY ✦</span></div>
                    <div class="marketing-title-group">
                        <h1 class="marketing-title">LOOMO</h1>
                        <h2 class="marketing-subtitle">The AI Operating System for Intelligent Enterprises</h2>
                    </div>
                    <p class="marketing-desc">One unified platform combining Autonomous AI Agents, Enterprise ERP, and Business Simulation — helping organizations automate, optimize, and transform how they operate, decide, and grow.</p>
                    ${loomoPlatformSliderMarkup()}
                </div>
                <div class="marketing-footer">
                    <span>© 2026 LOOMO</span>
                </div>
            `;
            pageContent.insertBefore(marketingSidebar, pageContent.firstChild);
            loomoInitPlatformSlider(marketingSidebar);
        }

        // Anti-FOUC: Reveal the layout smoothly
        const pageLogin = document.getElementById('page-login');
        if (pageLogin) {
            // Small timeout ensures the DOM has updated before we trigger the CSS transition
            setTimeout(() => {
                pageLogin.classList.add('loomo-layout-ready');
            }, 50);
        }

        // Insert 'OR' divider between Continue and Email Link buttons
        const emailLinkBtn = document.querySelector('.for-login .page-card-actions .btn-login-with-email-link');
        if (emailLinkBtn) {
            const divider = document.createElement('div');
            divider.className = 'loomo-or-divider';
            divider.innerHTML = '<span>OR</span>';
            emailLinkBtn.parentNode.insertBefore(divider, emailLinkBtn);
        }
    }
});
